import React from "react";
import Footer from "../Customer_pro/Footer";
import Header from "./Header";

const Support_faq = () => {
  return (
    <div>
      {/* <?php $bodyClass = 'pg-legacy'; ?>
<?php  include('head_meta.php');  ?>
<?php  include('header.php');  ?> */}
      <Header>
        <div className="content">
          <div class="mob_nav">
            <div class="row">
              <div class="col-7">
                <div class=" d-flex justify-content-start ">
                  <a href="javascript:window.history.back();" class="">
                    <i class="bi bi-arrow-left"></i>
                  </a>
                  <h2>Support</h2>
                </div>
              </div>
              <div class="col">
                <a href="/support_create_ticket" class="btn btn-primary">
                  Create Ticket
                </a>
              </div>
            </div>
          </div>

          <div class="row justify-content-between desk_nav">
            <div class="col-12 col-md-4 ">
              <div class="d-flex">
                <a href="javascript:window.history.back();" class="back_btn">
                  <i class="bi bi-arrow-90deg-left"></i>
                </a>
                <h2>Support</h2>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <div class="row justify-content-end">
                <div class="col-6 col-md-6">
                  <div class="d-grid">
                    <a
                      href="/support_create_ticket"
                      class="btn btn-primary btn-block"
                      // data-bs-toggle="modal"
                      // data-bs-target="#Warehouse_up"
                    >
                      <i class="bi bi-plus"></i> Create Ticket
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card mb-4">
            <div class="card-body">
              <div class=" rounded-3 pc-5">
                <div class="row">
                  <div class="col-12 col-md">
                    <div class="mb-3 p-3">
                      <h5 class="mb-3">How can we help?</h5>
                      <p class="mb-3">
                        Search for the topic you need help with or
                        <a href="#!" class="text-primary">
                          Contact our support
                        </a>
                      </p>
                    </div>
                  </div>
                  <div class="col-12 col-md">
                    <div class="text-center border border-dark rounded-3 p-3 m-auto mb-3">
                      <p class="fw-300 m-0">Reach Us</p>
                      <h3 class="text-black">
                        <a
                          href="callto:+91123456789"
                          data-bs-toggle="tooltip"
                          title="Call to Support"
                        >
                          <i class="bi bi-headset"></i> +91123456789
                        </a>{" "}
                        <i class="bi bi-dot"></i>
                        <a
                          href="mailto:hello@skyship.com"
                          data-bs-toggle="tooltip"
                          title="Mail Us"
                        >
                          <i class="bi bi-envelope"></i> hello@skyship.com
                        </a>
                      </h3>
                    </div>
                  </div>
                </div>

                {/* <!-- Row start --> */}
                <div class="row gx-3">
                  <div class="col-xxl-12">
                    <div class="card mb-3">
                      <div class="card-header">
                        <h5 class="card-title">FAQ's</h5>
                      </div>
                      <div class="card-body">
                        <div class="accordion" id="accordionFaq">
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOne">
                              <button
                                class="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                              >
                                What’s your return policy?
                              </button>
                            </h2>
                            <div
                              id="collapseOne"
                              class="accordion-collapse collapse show"
                              aria-labelledby="headingOne"
                              data-bs-parent="#accordionFaq"
                            >
                              <div class="accordion-body">
                                Discover 100s of premium admin themes &amp;
                                admin dashboards, including multipurpose and
                                responsive landing pages and HTML templates.
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="headingTwo">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseTwo"
                                aria-expanded="false"
                                aria-controls="collapseTwo"
                              >
                                How do I cancel my order?
                              </button>
                            </h2>
                            <div
                              id="collapseTwo"
                              class="accordion-collapse collapse"
                              aria-labelledby="headingTwo"
                              data-bs-parent="#accordionFaq"
                            >
                              <div class="accordion-body">
                                BootstrapGallery is the marketplace for premium
                                Bootstrap based admin dashboards, admin themes
                                and admin templates.
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="headingThree">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseThree"
                                aria-expanded="false"
                                aria-controls="collapseThree"
                              >
                                What are your shipping &amp; handling charges?
                              </button>
                            </h2>
                            <div
                              id="collapseThree"
                              class="accordion-collapse collapse"
                              aria-labelledby="headingThree"
                              data-bs-parent="#accordionFaq"
                            >
                              <div class="accordion-body">
                                Best admin dashboards and admin themes available
                                at reasonable price.
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="headingFour">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseFour"
                                aria-expanded="false"
                                aria-controls="collapseFour"
                              >
                                What are your shipping &amp; handling charges?
                              </button>
                            </h2>
                            <div
                              id="collapseFour"
                              class="accordion-collapse collapse"
                              aria-labelledby="headingFour"
                              data-bs-parent="#accordionFaq"
                            >
                              <div class="accordion-body">
                                Quality admin dashboards and admin themes
                                available at reasonable price.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-center pt-5 border border-dark p-3 wc-50 rounded-3 mt-5 m-auto">
                  <h3 class="text-black">Still can’t find your answer?</h3>
                  <p class="fw-300">We are happy to help!</p>
                  <a class="btn btn-outline-primary">Create Support Ticket</a>
                  <a class="btn btn-outline-primary">Contact us</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Header>
      <Footer />
    </div>
  );
};

export default Support_faq;
